import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Avatar,
  Button,
  Box,
  Container,
  Grid,
  Typography,
  makeStyles
} from '@material-ui/core';
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingTop: 128,
    paddingBottom: 128
  },
  avatar: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText
  }
}));

function Features({ className, ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Container maxWidth="lg">
        <Typography
          component="p"
          variant="overline"
          color="secondary"
          align="center"
        >
          {t('pages.homeView.homeDesc_FeatureHeader')}
        </Typography>
        <Typography
          variant="h1"
          align="center"
          color="textPrimary"
        >
          {t('pages.homeView.homeDesc_FeatureTitle')}
        </Typography>
        <Box mt={8}>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              xs={12}
              md={4}
            >
              <Box display="flex">
                <Avatar className={classes.avatar}>
                  01
                </Avatar>
                <Box ml={2}>
                  <Typography
                    variant="h4"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t('pages.homeView.homeDesc_Feature1_Title')}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="textPrimary"
                  >
                    {t('pages.homeView.homeDesc_Feature1_Desc1')}
                    {t('pages.homeView.homeDesc_Feature1_Desc2')}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Box display="flex">
                <Avatar className={classes.avatar}>
                  02
                </Avatar>
                <Box ml={2}>
                  <Typography
                    variant="h4"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t('pages.homeView.homeDesc_Feature2_Title')}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="textPrimary"
                  >
                    {t('pages.homeView.homeDesc_Feature2_Desc1')}
                    {t('pages.homeView.homeDesc_Feature2_Desc2')}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Box display="flex">
                <Avatar className={classes.avatar}>
                  03
                </Avatar>
                <Box ml={2}>
                  <Typography
                    variant="h4"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t('pages.homeView.homeDesc_Feature3_Title')}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="textPrimary"
                    gutterBottom
                  >
                    {t('pages.homeView.homeDesc_Feature3_Desc1')}
                    {t('pages.homeView.homeDesc_Feature3_Desc2')}
                  </Typography>
                  <Button
                    variant="outlined"
                    component="a"
                    href="https://sketch.cloud/s/q4a8e"
                    target="_blank"
                  >
                    {t('pages.homeView.homeDesc_Feature3_previewDesing')}
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
}

Features.propTypes = {
  className: PropTypes.string
};

export default Features;
